import styled from "styled-components";
import variaveis from "../../styles/variaveis.scss";

export const TitleStyle = styled.h5`
  && {
    font-size: 21px;
    color: ${variaveis.textDark};
    padding-top: 2%;
    padding-bottom: 1%;
    font-family: ${variaveis.fontFamilyTitles};
    font-weight: bold;
  }
`;
